import {
  Stepper,
  Step,
  StepLabel,
  Box,
  Button,
  Typography,
} from "@mui/material";
import React from "react";

interface StepItem {
  label: string;
  component: React.ReactNode;
  isRequired?: boolean;
}

interface CustomStepperProps {
  steps: StepItem[];
  activeStep: any;
  isStepSkipped: (step: number) => boolean;
  handleReset: () => void;
}

export const CustomStepper: React.FC<CustomStepperProps> = (props) => {
  return (
    <>
      <Stepper
        activeStep={props.activeStep}
        sx={{
          ml: "20% !important",
          mr: "20% !important",
        }}
      >
        {props.steps.map((item, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};

          if (props.isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={item.label} {...stepProps} disabled>
              <StepLabel {...labelProps} sx={{ cursor: "pointer !important" }}>
                {item.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {props.activeStep === props.steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={props.handleReset}>Reset</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Typography sx={{ mt: 1, mb: 0 }}>
            {props.steps[props.activeStep].component}
          </Typography>
        </React.Fragment>
      )}
    </>
  );
};
